<template>
  <div v-if="data.has_salary">
    <input
      type="checkbox"
      :id="`checkbox-${data.id}`"
      :name="`checkbox-${data.id}`"
      hidden
      ref="checkbox"
      v-model="data.output_salary"
      @change="toggleSalaryOutput"
    />
    <label class="custom-checkbox" :for="`checkbox-${data.id}`">
      <svg
        fill="currentColor"
        viewBox="0 0 20 20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
          clip-rule="evenodd"
        ></path>
      </svg>
    </label>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  methods: {
    toggleSalaryOutput() {
      this.$emit("toggleSalaryOutput", {
        company_id: this.data.id,
        checked: this.$refs.checkbox.checked,
      });
    },
  },
};
</script>

<style scoped lang="scss">
.custom-checkbox {
  appearance: none;
  padding: 0;
  print-color-adjust: exact;
  display: inline-block;
  vertical-align: middle;
  background-origin: border-box;
  flex-shrink: 0;
  height: 1rem;
  width: 1rem;
  color: white;
  background-color: #fff;
  border-color: #d1d5db;
  border-width: 1px;
  border-style: solid !important;
  border-radius: 0.2rem;
  cursor: pointer;
  position: relative;

  svg {
    width: 14px;
  }
}

[type="checkbox"]:checked + .custom-checkbox {
  background-color: #2563eb;
}
</style>